export default function(array, object) {
  const tmp = array.find(item => item._id === object._id);
  return tmp !== undefined;
}



// WEBPACK FOOTER //
// ./src/arkulpa-fec/utils/itemIsInList.js